export default __webpack_public_path__ + "static/Score-52d3c1219780cc6f89294b0dca629aeb.png";